import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useBookingStore = create(
  persist(
    (set) => ({
  // Quote data
  quoteId: null,
  quoteData: null,

  // Step 1: Route information
  fromLabel: '',
  toLabel: '',
  pickupAt: '',
  pickupTime: '12:00',
  passengers: 1,
  isRoundtrip: false,
  returnAt: '',
  returnTime: '12:00',

  // Step 2: Selected vehicle
  selectedVehicle: null,

  // Step 3: Customer details and addons
  customerInfo: {
    full_name: '',
    email: '',
    phone: ''
  },
  pickupAddress: '',
  pickupExactAddress: '',
  dropoffExactAddress: '',
  notes: '',
  flightNumber: '',
  luggageCount: 0,
  selectedAddons: [],

  // Step 4: Reservation (persisted to survive navigation)
  reservationId: null,
  totalAmount: 0,
  reservationCreated: null,

  // Captcha token (NOT persisted)
  captchaToken: null,

  // Current wizard step
  currentStep: 0,

  // Actions
  setQuoteData: (quoteId, quoteData) => set({
    quoteId,
    quoteData,
    // New quote = new session → clear stale data from previous booking
    selectedVehicle: null,
    selectedAddons: [],
    flightNumber: '',
    luggageCount: 0,
    reservationCreated: null,
    reservationId: null,
    totalAmount: 0
  }),

  setRouteInfo: (data) => set({
    fromLabel: data.fromLabel,
    toLabel: data.toLabel,
    pickupAt: data.pickupAt,
    pickupTime: data.pickupTime,
    passengers: data.passengers,
    isRoundtrip: data.isRoundtrip,
    returnAt: data.returnAt || '',
    returnTime: data.returnTime || '12:00'
  }),

  setSelectedVehicle: (vehicle) => set({ selectedVehicle: vehicle }),

  setCustomerInfo: (info) => set({ customerInfo: info }),

  setPickupAddress: (pickupAddress) => set({ pickupAddress }),
  setPickupExactAddress: (pickupExactAddress) => set({ pickupExactAddress }),
  setDropoffExactAddress: (dropoffExactAddress) => set({ dropoffExactAddress }),

  setNotes: (notes) => set({ notes }),
  setFlightNumber: (flightNumber) => set({ flightNumber }),
  setLuggageCount: (luggageCount) => set({ luggageCount }),

  setSelectedAddons: (addons) => set({ selectedAddons: addons }),

  setReservation: (reservationId, totalAmount) => set({ reservationId, totalAmount }),

  setReservationCreated: (reservation) => set({ reservationCreated: reservation }),

  setCaptchaToken: (token) => set({ captchaToken: token }),

  setCurrentStep: (step) => set({ currentStep: step }),

  nextStep: () => set((state) => ({ currentStep: state.currentStep + 1 })),

  prevStep: () => set((state) => ({ currentStep: Math.max(0, state.currentStep - 1) })),

  resetBooking: () => set({
    quoteId: null,
    quoteData: null,
    fromLabel: '',
    toLabel: '',
    pickupAt: '',
    pickupTime: '12:00',
    passengers: 1,
    isRoundtrip: false,
    returnAt: '',
    returnTime: '12:00',
    selectedVehicle: null,
    customerInfo: { full_name: '', email: '', phone: '' },
    pickupAddress: '',
    pickupExactAddress: '',
    dropoffExactAddress: '',
    notes: '',
    flightNumber: '',
    luggageCount: 0,
    selectedAddons: [],
    reservationId: null,
    totalAmount: 0,
    reservationCreated: null,
    captchaToken: null,
    currentStep: 0
  })
}),
{
  name: 'booking-storage',
  partialize: (state) => ({
    quoteId: state.quoteId,
    quoteData: state.quoteData,
    fromLabel: state.fromLabel,
    toLabel: state.toLabel,
    pickupAt: state.pickupAt,
    pickupTime: state.pickupTime,
    passengers: state.passengers,
    isRoundtrip: state.isRoundtrip,
    returnAt: state.returnAt,
    returnTime: state.returnTime,
    selectedVehicle: state.selectedVehicle,
    customerInfo: state.customerInfo,
    pickupAddress: state.pickupAddress,
    pickupExactAddress: state.pickupExactAddress,
    dropoffExactAddress: state.dropoffExactAddress,
    notes: state.notes,
    flightNumber: state.flightNumber,
    luggageCount: state.luggageCount,
    selectedAddons: state.selectedAddons,
    currentStep: state.currentStep,
    reservationCreated: state.reservationCreated
  })
}
)
);
